import { server_ip } from "../config";

export async function fetchRegistrationFormTemplates(token, filter, options , project=null) {
    try {
        const response = await fetch(`${server_ip}/api/registrationFormTemplates/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options,
                ...project?{project}:{}
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function fetchRegistrationFormTemplateById(id) {
    try {
        const response = await fetch(`${server_ip}/api/registrationFormTemplates/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function updateRegistrationFormTemplates(token, id, data) {
    try {
        const response = await fetch(`${server_ip}/api/registrationFormTemplates/${id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ data })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}
export async function insertRegistrationFormTemplate(token, data) {
    try {
        const response = await fetch(`${server_ip}/api/registrationFormTemplates`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ data })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function deleteRegistrationFormTemplate(token, id) {
    try {
        const response = await fetch(`${server_ip}/api/registrationFormTemplates/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}